import connect from "../../../shared/data-store/connect";
import { ACTION_CHANGE_BOARD_FILTER, store } from "./DataStore";
import { track } from "../../tracker/EventTracker";
import * as Board from "@escapio/portal/components/board";
import BoardFilter from "../BoardFilter";

customElements.define(
	"esc-favorites-board-filter",
	class extends connect(BoardFilter, store) {
		update({ filters }, { priceFiltersVisible }) {
			this.render(filters.board, priceFiltersVisible);
		}

		onChange(event) {
			const { value } = event.target;
			this.dispatchAction(ACTION_CHANGE_BOARD_FILTER, value);
			track("Filter (Merkliste)", "Preis Filter", Board.TRACKING_LABELS[value]);
		}
	},
);
